var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 222,
    viewBox: "0 0 374 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_48087",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -124,
    width: 374,
    height: 346
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.198 205.946C256.417 220.634 291.115 224.068 322.642 215.391C333.679 212.354 344.573 207.73 352.869 199.841C362.753 190.444 368.169 177.049 369.955 163.525C372.978 140.636 374.306 44.9024 373.941 -123.676H0C0 51.8204 0 145.566 0 157.56C0 174.357 13.9105 222 65.2209 222C85.0591 222 97.3281 199.984 114.34 191.565C139.101 179.309 169.318 177.504 194.839 188.57C206.076 193.443 216.255 200.445 227.198 205.946Z",
    fill: "#F0F0F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_48087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.839 188.57C206.076 193.443 216.255 200.445 227.198 205.946C256.417 220.634 291.115 224.068 322.642 215.391C333.679 212.354 344.573 207.73 352.869 199.841C362.753 190.444 368.169 177.049 369.955 163.525C374.489 129.191 356.258 94.2769 328.582 73.4744C306.376 56.7811 279.053 46.0742 251.51 46.0742C168.65 46.0742 159.261 89.0816 91.6908 74.1812C35.4093 61.77 0 107.168 0 157.56C0 174.357 13.9105 222 65.2208 222C85.0591 222 97.3281 199.984 114.34 191.564C139.101 179.309 169.318 177.504 194.839 188.57Z",
    fill: "#82A6C9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_405_48087",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -124,
    width: 374,
    height: 346
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.198 205.946C256.417 220.634 291.115 224.068 322.642 215.391C333.679 212.354 344.573 207.73 352.869 199.841C362.753 190.444 368.169 177.049 369.955 163.525C372.978 140.636 374.306 44.9024 373.941 -123.676H0C0 51.8204 0 145.566 0 157.56C0 174.357 13.9105 222 65.2209 222C85.0591 222 97.3281 199.984 114.34 191.565C139.101 179.309 169.318 177.504 194.839 188.57C206.076 193.443 216.255 200.445 227.198 205.946Z",
    fill: "#707070"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_405_48087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.555 175.539H-18.9805V284.254H404.555V175.539Z",
    fill: "#103559"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.838 0H61.9331C59.7264 0 57.9375 1.78617 57.9375 3.98953V58.8456C57.9375 61.049 59.7264 62.8351 61.9331 62.8351H148.838C151.045 62.8351 152.833 61.049 152.833 58.8456V3.98953C152.833 1.78617 151.045 0 148.838 0Z",
    fill: "#5380AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.373 30.919C125.269 30.919 130.859 25.3372 130.859 18.4517C130.859 11.5662 125.269 5.98438 118.373 5.98438C111.477 5.98438 105.887 11.5662 105.887 18.4517C105.887 25.3372 111.477 30.919 118.373 30.919Z",
    fill: "#C1D3E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9375 37.9673C65.3747 26.8373 72.5578 21.2722 79.4868 21.2722C89.8803 21.2722 103.678 44.4936 116.546 47.3976C125.125 49.3336 137.221 46.1902 152.833 37.9673V58.8449C152.833 61.0482 151.045 62.8344 148.838 62.8344H61.9331C59.7264 62.8344 57.9375 61.0482 57.9375 58.8449V37.9673Z",
    fill: "#2B5580"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.279 170.985H214.314C216.446 170.985 218.174 172.711 218.174 174.84H156.418C156.418 172.711 158.146 170.985 160.279 170.985Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.575 155.568H187.295V170.975C178.58 171.003 179.575 170.975 171.855 170.975C177.002 166.472 179.575 161.336 179.575 155.568ZM195.014 155.568C195.014 161.336 197.587 166.472 202.734 170.975C195.014 170.975 196.009 171.003 187.295 170.975V155.568H195.014Z",
    fill: "#5380AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.07 26.4307H98.5203C94.2569 26.4307 90.8008 29.8816 90.8008 34.1384V147.859C90.8008 152.116 94.2569 155.567 98.5203 155.567H276.07C280.333 155.567 283.789 152.116 283.789 147.859V34.1384C283.789 29.8816 280.333 26.4307 276.07 26.4307Z",
    fill: "#C1D3E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_405_48087",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 26,
    width: 194,
    height: 130
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.07 26.4307H98.5203C94.2569 26.4307 90.8008 29.8816 90.8008 34.1384V147.859C90.8008 152.116 94.2569 155.567 98.5203 155.567H276.07C280.333 155.567 283.789 152.116 283.789 147.859V34.1384C283.789 29.8816 280.333 26.4307 276.07 26.4307Z",
    fill: "#545454"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_405_48087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8008 26.4307H283.789V36.0677H90.8008V26.4307Z",
    fill: "#1B456E"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283.789 36.0693H90.8008V145.932H283.789V36.0693Z",
    fill: "#FFF9EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.395 151.641C300.431 148.485 295.903 134.573 302.813 109.904C322.516 125.981 327.043 139.893 316.395 151.641Z",
    fill: "#5380AC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.794 151.163C307.841 139.767 314.655 130.74 333.233 124.081C331.655 143.569 324.842 152.597 312.794 151.163Z",
    fill: "#C1D3E4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.193 151.584C294.755 151.9 288.925 142.21 289.701 122.516C307.207 131.278 313.037 140.967 307.193 151.584Z",
    fill: "#1B456E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.785 147.613H326.539C327.7 147.613 328.641 148.557 328.641 149.722V150.309C328.641 151.258 328.161 152.141 327.367 152.656L325.858 153.633V160.396C325.858 164.062 324.839 167.655 322.915 170.772L322.829 170.912C321.053 173.789 317.921 175.539 314.549 175.539H303.775C300.403 175.539 297.271 173.789 295.496 170.912L295.409 170.772C293.485 167.655 292.466 164.062 292.466 160.396V153.633L290.957 152.656C290.163 152.141 289.684 151.258 289.684 150.309V149.722C289.684 148.557 290.624 147.613 291.785 147.613Z",
    fill: "#E6E6E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.643 153.597H304.057L302.668 156.589H325.643V153.597Z",
    fill: "#5380AC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0532 82.7827C31.4517 90.9429 37.6722 99.9069 33.7147 109.675C37.9041 121.416 40.2442 136.831 39.9287 154.594C38.414 137.094 35.8201 122.855 32.147 111.878C19.9801 111.919 14.2828 102.22 15.0532 82.7827Z",
    fill: "#1B456E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8609 96.7461C48.4624 104.906 42.2419 113.87 46.1994 123.638C42.0099 135.38 39.6699 150.795 39.9853 168.558C41.5 151.057 44.0939 136.819 47.7671 125.842C59.9339 125.882 65.6313 116.183 64.8609 96.7461Z",
    fill: "#5380AC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8055 59.843C44.73 71.0765 37.0742 83.6065 44.8383 97.4327C41.5088 114.683 39.7045 143.887 39.9849 159.581C40.8715 140.635 43.3891 119.93 47.5377 97.4658C62.1741 96.5794 68.9295 84.0384 67.8055 59.843Z",
    fill: "#386694"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1001 61.8379C39.1047 67.2669 42.9788 73.5107 38.7223 80.5693L38.7081 80.5686C40.7499 88.8413 41.0879 103.85 40.9198 118.712L40.8974 120.482C40.7334 132.272 40.2799 143.797 40.1378 151.602C40.1378 114.23 38.9009 90.5334 36.4272 80.5134C29.3921 79.7743 26.2832 73.5486 27.1001 61.8379Z",
    fill: "#103559"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.078 146.615H57.8324C58.993 146.615 59.9338 147.559 59.9338 148.724V149.312C59.9338 150.26 59.4543 151.144 58.6604 151.658L57.1512 152.636V159.398C57.1512 163.064 56.132 166.658 54.2084 169.774L54.1216 169.915C52.346 172.792 49.214 174.542 45.8422 174.542H35.0683C31.6964 174.542 28.5645 172.792 26.7888 169.915L26.702 169.774C24.7784 166.658 23.7592 163.064 23.7592 159.398V152.636L22.25 151.658C21.4561 151.144 20.9766 150.26 20.9766 149.312V148.724C20.9766 147.559 21.9174 146.615 23.078 146.615Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9397 152.6H35.3541L33.9648 155.592H56.9397V152.6Z",
    fill: "#5380AC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.801 65.2859H190.791V97.0027H181.801V65.2859ZM186.296 109.085C188.778 109.085 190.791 107.057 190.791 104.554C190.791 102.052 188.778 100.023 186.296 100.023C183.813 100.023 181.801 102.052 181.801 104.554C181.801 107.057 183.813 109.085 186.296 109.085Z",
    fill: "#1B456E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2b9e83cf1ea0c5abc8bcba5b3548af12.svg";
export { ForwardRef as ReactComponent };